export default function camelCase(value: string) {
  return value.replace(/-([a-z])/g, (x, char) => char.toUpperCase());
}